// {{BASE_URL}}/api/schemeType
import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

export interface IDataItems {
  payment_reminder_msid_id: number;
  vat_return_version_id: number;
  reminded_date: Date;
  is_sent: boolean;
}

export interface IPaymentRemindersListOutput {
  items: IDataItems[];
  paging: IPaging;
}

export interface IPaymentRemindersListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vatNumber?: string | null;
  vatReturnReference?: string | null;
  remindedDateFrom?: string | null;
  remindedDateTo?: string | null;
}

export interface IPaging {
  page: number;
  pageSize: number;
  total: number;
}

export const fetchPaymentRemindersList = async (
  payload: IPaymentRemindersListInput
): Promise<Types.ResponseOutput> => {
  const queryParams = new URLSearchParams({
    page: payload.page.toString(),
    pageSize: payload.pageSize.toString(),
    sortField: payload.sortField,
    order: payload.order,
  });
  if (payload.vatNumber) queryParams.set('vatNumber', payload.vatNumber);
  if (payload.vatReturnReference)
    queryParams.set('vatReturnReference', payload.vatReturnReference);
  if (payload.remindedDateFrom)
    queryParams.set('remindedDateFrom', payload.remindedDateFrom);
  if (payload.remindedDateTo)
    queryParams.set('remindedDateTo', payload.remindedDateTo);
  const { data }: any = await request(
    'get',
    `${
      Environment.API_BASE_URL
    }/api/payment-reminders/list?${queryParams.toString()}`
  );

  let _data: IPaymentRemindersListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const paymentRemindersToGenerate =
  async (): Promise<Types.ResponseOutput> => {
    const { data }: any = await request(
      'post',
      `${Environment.API_BASE_URL}/api/payment-reminders/generate`
    );

    let output: Types.ResponseOutput = {
      message: data.message,
      data: data.data,
      status: data.status,
    };
    return output;
  };
